import { render, staticRenderFns } from "./tacAccessDevices.vue?vue&type=template&id=c28afbae&scoped=true"
import script from "./tacAccessDevices.vue?vue&type=script&lang=js"
export * from "./tacAccessDevices.vue?vue&type=script&lang=js"
import style0 from "./tacAccessDevices.vue?vue&type=style&index=0&id=c28afbae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c28afbae",
  null
  
)

export default component.exports